// frontend/src/utils/dateUtils.js
import moment from "moment";
import { getOperatingHours } from "./constants";

/**
 * Format a date to display in a user-friendly way
 * @param {Date} date - Date to format
 * @returns {string} - Formatted date string
 */
export const formatDate = (date) => {
  return date.toLocaleDateString("en-US");
};

/**
 * Format a time to display in a user-friendly way
 * @param {Date} date - Date to format
 * @returns {string} - Formatted time string
 */
export const formatTime = (date) => {
  return date.toLocaleTimeString("en-US", {
    timeZone: "America/Phoenix",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

/**
 * Format a date and time to display in a user-friendly way
 * @param {Date} date - Date to format
 * @returns {string} - Formatted date and time string
 */
export const formatDateTime = (date) => {
  return `${formatDate(date)} ${formatTime(date)}`;
};

/**
 * Format a birthdate to show only month and day
 * @param {Date|string} birthday - Birthday date
 * @returns {string} - Formatted birthdate string
 */
export const formatBirthdate = (birthday) => {
  if (!birthday) return "";

  const dateObj = new Date(birthday);
  return `${dateObj.toLocaleString("default", {
    month: "long",
  })} ${dateObj.getDate()}`;
};

/**
 * Get min and max time for calendar based on operating hours
 * @returns {Object} - Object with minTime and maxTime
 */
export const getCalendarTimeConstraints = () => {
  const currentDate = new Date();
  const { startHour, endHour } = getOperatingHours(moment(currentDate));

  const minTime = moment(currentDate).startOf("day").hour(startHour).toDate();
  const maxTime = moment(currentDate).startOf("day").hour(endHour).toDate();

  return { minTime, maxTime };
};

/**
 * Check if a date is in the past
 * @param {Date} date - Date to check
 * @returns {boolean} - True if date is in the past
 */
export const isPastDate = (date) => {
  return new Date(date) < new Date();
};
